export default function featureFlag({ app }) {
  if (app.$auth.user.username !== 'visitroopers@holaluz.com') {
    throw new Error('not-valid-user')
  }
}
